import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { CTAButton } from '../../controls/ButtonBase';
import { useLocalization } from '../../context/Localization/localization';
import { Heading } from '../../controls/Heading/Heading';
import { nameof } from '../../helpers/nameof';
import { useAppointmentState, useAppointmentUpdateAndPersist } from '../../context/Appointment/appointment';
import { Types, useCartDispatch } from '../../context/cart';
import { useRestartOnBackAfterSignature } from '../../helpers/Hooks';
import { GMFormTextArea } from '../../controls/TextField';
import { GMForm } from '../../controls/Form';

export interface TowInAdditionalDetailsProps {
    onProceed: () => void;
}

export const TowInAdditionalDetails: React.FC<TowInAdditionalDetailsProps> = (props) => {
    useRestartOnBackAfterSignature();
    const Localization = useLocalization();
    const appointment = useAppointmentState();
    const setAppointment = useAppointmentUpdateAndPersist();
    const cartDispatch = useCartDispatch();

    const initialValues = {
        comment: appointment.comment,
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values) => {
                cartDispatch({ type: Types.UpdateComment,
                    payload: { key: 'Services',
                        comment: values.comment ?? '' } });
                await setAppointment({ ...appointment,
                    comment: values.comment }, false, false, false, true, undefined, false, false, false, false, true);
                props.onProceed();
            }}
            validationSchema={Yup.object()
                .shape({
                    [nameof<typeof initialValues>('comment')]: Yup.string()
                        .nullable(),
                })}
        >
            <GMForm
                heading={
                    <Heading
                        secondaryHeading={Localization.IsThereAnythingElseYouWouldLikeToTellUsAboutTheVehicleOrCustomer}
                        leftAlign
                    />
                }
                submitButton={
                    <CTAButton
                        styleType={'primary'}
                        type={'submit'}
                        title={Localization.ClickToProceedToNextStep}
                        label={Localization.Proceed}
                        id={Localization.ClickToProceedToNextStep}
                        ariaLabel={Localization.ClickToProceedToNextStep}
                    />
                }
                topDivider
                fullWidthKioskInputs
            >
                <GMFormTextArea
                    name={nameof<typeof initialValues>('comment')}
                    id={nameof<typeof initialValues>('comment')}
                    title={Localization.TypeAdditionalDetailsHere}
                    label={''}
                    ariaLabel={Localization.TypeAdditionalDetailsHere}
                    placeholder={Localization.TypeAdditionalDetailsHere}
                    autoFocus
                    shiftAfterPeriod
                />
            </GMForm>
        </Formik>
    );
};
